import { serverHost } from '../../config'
import { AuthService } from '../auth-service'
import ApiService from '../api-service'

class UserMessageService {
  sourceURL

  constructor() {
    this.sourceURL = `${serverHost}/api/user/message`
  }

  getMessageRightAnswerModal = () => {
    const queryOption = {
      headers: AuthService.authHeaders(),
    }
    return ApiService.request(`${this.sourceURL}/writeComment`, queryOption)
  }
}

export default UserMessageService
